import React from 'react'
import styled from '@emotion/styled'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { colors } from 'parameters/ui'
import { mediaQueriesByDevice } from 'parameters/viewport'
import { FavoriteButton } from 'experiences/learn/articles/FavoriteButton/FavoriteButton'
import { SEOLink } from 'components/elements/links/SEOLink'
import { createPendingComponent, PendingFC } from 'components/patterns/suspense/componentWrappers'
import { BlockSkeleton } from 'components/patterns/Skeleton/blocks/ShapedSkeletons'
import { sk } from 'components/patterns/Skeleton'

// TODO: https://github.com/EVENFinancial/cro-fionacom-web/pull/613/files#r702613285
const imageSizes = '(min-width: 768px) 128px, 20vw'

const ArticleItemView: PendingFC<ArticleSummary> = props => {
	let image = <BlockSkeleton length={55} cornerRadius={8} />
	if (!props.pending) {
		image = (
			<ContentfulImage
				asset={props.primaryImage}
				width={295}
				height={166}
				layout="fill"
				objectFit="cover"
				quality={60}
				sizes={imageSizes}
			/>
		)
	}
	const article = props
	return (
		<SEOLink href={{ pathname: article?.relativePath || '#' }}>
			<Wrapper>
				<ImageWrapper>{image}</ImageWrapper>
				<Flexbox>
					<TextSection>
						<Title>{sk(article?.title)}</Title>
						<Category>{sk(article?.category)}</Category>
					</TextSection>
					<FavoriteButton id={article?.id || ''} />
				</Flexbox>
			</Wrapper>
		</SEOLink>
	)
}

export const ArticleItem = createPendingComponent(ArticleItemView)

const Wrapper = styled.div`
	display: flex;
	width: 100%;
	margin-bottom: 16px;

	img {
		border-radius: 8px;
	}

	${mediaQueriesByDevice.mobilePortrait} {
		flex-direction: column;
		width: calc(100vw - 88px); // 88px equals to horizontal paddings of containers
		scroll-snap-align: start;
		flex-shrink: 0;
		border-radius: 10px;
		transform-origin: center center;
		transform: scale(1);
		transition: transform 0.5s;
		position: relative;

		> div:last-of-type {
			align-items: center;
		}
	}
`

const ImageWrapper = styled.div`
	width: 62px;
	border-radius: 8px;
	position: relative;

	${mediaQueriesByDevice.mobilePortrait} {
		width: 100%;
		height: 105px;
		overflow: hidden;
	}
`

const Title = styled.p`
	font-weight: bold;
	font-size: 20px;
	line-height: 140%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 420px;
	color: ${colors.black};

	${mediaQueriesByDevice.mobilePortrait} {
		max-width: unset;
		white-space: unset;
		-webkit-line-clamp: 2;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
`

const Category = styled.p`
	color: ${colors.primaryDarkGrey1};
`

const Flexbox = styled.div`
	display: flex;
	flex-grow: 1;
	justify-content: space-between;
	margin-left: 16px;

	${mediaQueriesByDevice.mobilePortrait} {
		margin-top: 16px;
		margin-left: 0;
	}
`

const TextSection = styled.div`
	${mediaQueriesByDevice.mobilePortrait} {
		padding-right: 16px;
	}
`
